import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import CompactLayout from 'src/layouts/compact';

const Page404 = lazy(() => import('src/pages/404/404-page'));
const TermsPrivacyPolicyPage = lazy(() => import('src/pages/public-terms/privacy-policy/terms-privacy-policy-page'));
const TermsServicePage = lazy(() => import('src/pages/public-terms/service/terms-service-page'));
const CsPage = lazy(() => import('src/pages/cs/cs-page'));

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      { path: '404', element: <Page404 /> },
      { path: 'public-terms/service', element: <TermsServicePage /> },
      { path: 'public-terms/privacy-policy', element: <TermsPrivacyPolicyPage /> },
      { path: 'cs', element: <CsPage /> }
    ]
  }
];
